import axios from "axios";
import { useState } from "react";
import { APIConstants } from "../../constants/ApiConstants";
import { useDispatch } from "react-redux";
import { merchantActions } from "../../redux/slices/merchantSlice";
import merchantPic from "../../assets/voucher.png";
import { filterConstants } from "../../constants/AppConstants";
import { getMerchant } from "../../services/ApiServices/getMerchant";
import { useAppSelector } from "../../redux/hooks";

const useGetMerchants = () => {
  const [merchantLoading, setLoading] = useState(false);
  const [merchantData, setMerchantData] = useState<any>([]);
  const [isMerchantError, setisMerchantError] = useState<boolean>(false);
  const dispatch = useDispatch();
  const entireList = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList.entireListOfMerchants
  );
  const fetchMerchantList = async (urlString?: string) => {
    try {
      setLoading(true);
      const data = await getMerchant(urlString);
      if (data) {
        const mapData = data?.map((merchant: any) => {
          const companyNameField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "companyName"
          );
          const companyName = companyNameField ? companyNameField.value : "-";

          const promoImageField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "merchant_logo"
          );

          const promoImage = promoImageField
            ? promoImageField.value
            : merchantPic;
          const directorySubCategoryField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "sub_category"
          );
          const directorySubCategory = directorySubCategoryField
            ? directorySubCategoryField.value
            : "-";

          const categoryField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "category"
          );
          const category = categoryField ? categoryField.value : "-";

          const evoucheracceptedField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "evoucheraccepted"
          );
          const acceptsVoucher = evoucheracceptedField
            ? evoucheracceptedField.value === "1"
              ? filterConstants.Yes
              : filterConstants.No
            : "-";

          const hidefromdirectoryField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "hideFromDirectory"
          );
          const hideFromDirectory = hidefromdirectoryField
            ? hidefromdirectoryField.value === "1"
              ? filterConstants.Yes
              : filterConstants.No
            : "-";

          const paywithpointsField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "paywithpoints"
          );
          const payWithPoints = paywithpointsField
            ? paywithpointsField.value === "1"
              ? filterConstants.Yes
              : filterConstants.No
            : "-";

          const isHalalCertified = merchant.custom_fields.field?.find(
            (field: any) => field.name === "halal_certified"
          );
          const HalalCertified = isHalalCertified
            ? isHalalCertified.value === "1"
              ? filterConstants.Yes
              : filterConstants.No
            : "-";
          const issponsoredField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "isSponsored"
          );
          const issponsored = issponsoredField
            ? issponsoredField.value === "1"
              ? filterConstants.Yes
              : filterConstants.No
            : "-";

          const unitNumberField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "unit_number"
          );
          const unitNumber = unitNumberField ? unitNumberField.value : "";
          const logoField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "merchant_logo"
          );
          const logo = logoField ? logoField.value : "";
          const webLogoField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "merchant_web_logo"
          );
          const webLogo = webLogoField ? webLogoField.value : "";
          const detailImageField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "detail_image"
          );
          const detailImage = detailImageField ? detailImageField.value : "";
          const websiteField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "merchant_website"
          );
          const website = websiteField ? websiteField.value : "";
          const openingHoursField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "openinghours"
          );
          const openingHours = openingHoursField ? openingHoursField.value : "";
          const aboutMerchantField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "about_merchant"
          );
          const aboutMerchant = aboutMerchantField
            ? aboutMerchantField.value
            : "";
          const isFeaturedField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "isFeatured"
          );
          const isFeatured = isFeaturedField ? isFeaturedField.value : false;

          const isParticipatingField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "isParticipating"
          );
          const isParticipating = isParticipatingField
            ? isParticipatingField.value
            : false;
          const getZoneField = merchant.custom_fields.field?.find(
            (field: any) => field.name === "store_zone"
          );
          const getZone = getZoneField ? getZoneField.value : "";

          const getTowerNo = merchant.custom_fields.field?.find(
            (field: any) => field.name === "tower_no"
          );
          const tower_no = getTowerNo ? getTowerNo.value : "";

          return {
            promoImage: promoImage,
            storeName: merchant.name || "-",
            unit_number: merchant.unit_number || "-",
            merchant_name: merchant.name || "",
            merchant_logo: logo,
            merchant_web_logo: webLogo,
            promo_image: promoImage,
            detail_image: detailImage,
            directory_category: category,
            directory_subcategory: directorySubCategory,
            username: merchant.name || "",
            email: merchant.email,
            website: website,
            mobile_no: merchant.mobile,
            about_merchant: aboutMerchant,
            opening_hours: openingHours,
            isFeatured: isFeatured,
            isParticipating: isParticipating,
            hideFromDirectory: hideFromDirectory,
            company_name: companyName,
            companyName: companyName,
            directoryCategory: category,
            directorySubCategory: directorySubCategory,
            towerNumber: tower_no,
            zone: getZone,
            leaseID: merchant.id || "-",
            isSponsored: issponsored,
            acceptsVoucher: acceptsVoucher,
            partner: merchant.partner || "-",
            payWithPoints: payWithPoints,
            HalalCertified: HalalCertified,
            external_id: merchant.external_id,
            status:
              merchant.is_active === "1"
                ? filterConstants.Active
                : filterConstants.Inactive,
            navigateTo: merchant.id
              ? `/viewMerchantDetails/${merchant.id}`
              : "-",
            is_active: merchant.is_active,
          };
        });
        setMerchantData(mapData);
        setisMerchantError(false);
        dispatch(merchantActions.updateMerchantList({ merchantList: mapData }));
        if (!entireList.length) {
          dispatch(
            merchantActions.updateEntireListOfMerchants({
              entireListOfMerchants: data,
            })
          );
        }
      } else {
        setMerchantData([]);
        setisMerchantError(true);
      }
    } catch (error) {
      setLoading(false);
      setisMerchantError(true);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return { fetchMerchantList, merchantLoading, merchantData, isMerchantError, setMerchantData };
};
export default useGetMerchants;
